import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  host: { 'test-id': 'operation-table' },
  selector: 'operation-table',
  styleUrls: ['./operation-table.component.scss'],
  templateUrl: './operation-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperationTable { }
